import { Observable } from 'rxjs';
import { ofType } from 'redux-observable';
import { map } from 'rxjs/operators';
import { Actions } from '../../actions';
import { DowngradeRecordLabelSuccess } from '../action-creators';
import { DOWNGRADE_RECORD_LABEL_SUCCESS } from '../actions';
import { push } from 'connected-react-router';

export const downgradeSuccessRedirectEpic = (action$: Observable<Actions>) =>
  action$.pipe(
    ofType<Actions, DowngradeRecordLabelSuccess>(
      DOWNGRADE_RECORD_LABEL_SUCCESS
    ),
    map((action) => {
      return push(
        `/plans/${action.recordLabelId}/${action.subscriptionId}/downgrade-success`
      );
    })
  );
